import React from "react";
import {
  Dialog,
  Button,
  DialogActions,
  DialogTitle,
  Typography,
  Box,
} from "@tiny/components";
import { useMergeAudienceDialog } from "./AudienceMergeDialog.hooks";
import { useStyles } from "./AudienceMerge.styles";
import AudienceSource from "./AudienceSource/AudienceSource";
import AudienceDestination from "./AudienceDestination/AudienceDestination";
import { SegmentView } from "@tiny/api";

export interface MergeAudienceDialogProps {
  open: boolean;
  audiences: SegmentView[];
  onClose: () => void;
}

function MergeAudienceDialog(props: MergeAudienceDialogProps) {
  const { open, onClose } = props;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      disableEscapeKeyDown
      disableBackdropClose
    >
      <MergeAudienceDialogContent {...props} />
    </Dialog>
  );
}

function MergeAudienceDialogContent(props: MergeAudienceDialogProps) {
  const {
    destinationAudience,
    destinationAudienceName,
    destinationParentBoxRef,
    handleDestinationDragEnd,
    handleDestinationDragOver,
    handleDestinationDragStart,
    handleDestinationDrop,
    handleMergeAudiences,
    handleSourceDragOver,
    handleSourceDragStart,
    handleSourceDrop,
    onClose,
    setDestinationAudience,
    setDestinationAudienceName,
    setSourceAudiences,
    sourceAudiences,
    sourceParentBoxRef,
    isAudienceMerging,
    mergeDisabled,
  } = useMergeAudienceDialog(props);

  const classes = useStyles();

  return (
    <>
      <DialogTitle onClose={onClose}>Merge audience</DialogTitle>
      <Box className={classes.dialogContainer}>
        <Box className={classes.titleContainer}>
          <Typography tone={900} color="grey">
            Source ({sourceAudiences?.length ?? 0})
          </Typography>
        </Box>
        <AudienceSource
          items={sourceAudiences}
          setItems={setSourceAudiences}
          destinationAudience={destinationAudience}
          setDestinationAudience={setDestinationAudience}
          handleDragOver={handleSourceDragOver}
          handleDragStart={handleSourceDragStart}
          handleDrop={handleSourceDrop}
          sourceParentBoxRef={sourceParentBoxRef}
        />
        <Box className={classes.titleContainer}>
          <Typography tone={900} color="grey">
            Destination
          </Typography>
        </Box>
        <AudienceDestination
          destinationAudience={destinationAudience}
          destinationAudienceName={destinationAudienceName}
          parentBoxRef={destinationParentBoxRef}
          handleDragEnd={handleDestinationDragEnd}
          handleDragOver={handleDestinationDragOver}
          handleDragStart={handleDestinationDragStart}
          handleDrop={handleDestinationDrop}
          setDestinationAudienceName={setDestinationAudienceName}
        />
      </Box>
      <DialogActions>
        <Button
          onClick={handleMergeAudiences}
          loading={isAudienceMerging}
          variant="contained"
          disabled={mergeDisabled}
        >
          Merge
        </Button>
      </DialogActions>
    </>
  );
}

export default MergeAudienceDialog;
